import { DTOSignUpPostFlowResponse } from 'src/apis/dto/DTOSignUpPostFlowResponse';
import { RestQueryOptions, useRestQuery } from 'src/hooks/useRestQuery';

export enum SignupPostFlowApiList {
  GetSignupPostFlow = '/api/v1/signup/post-flow',
}

const useSignupPostFlowQuery = (
  options: RestQueryOptions<DTOSignUpPostFlowResponse, void> = {}
) => {
  return useRestQuery<void, DTOSignUpPostFlowResponse, void>({
    path: SignupPostFlowApiList.GetSignupPostFlow,
    options,
  });
};

export default useSignupPostFlowQuery;
